import React from 'react';

interface InputBoxProps {
  type: string;
  id: string;
  placeholder: string;
  value: string;
  required: boolean;
  className: string;
  onChange: (value: string) => void;
  icon?: React.ReactNode;
  style?: React.CSSProperties;
}

const InputBox: React.FC<InputBoxProps> = ({ 
  type, 
  id, 
  placeholder, 
  value, 
  required, 
  className, 
  onChange,
  icon,
  style
}) => {
  return (
    <div className="relative">
      {icon && (
        <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-orange-500">
          {icon}
        </div>
      )}
      <input
        type={type}
        id={id}
        placeholder={placeholder}
        value={value}
        required={required}
        className={className}
        style={style}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
};

export default InputBox;
export { default as PageHeader } from './PageHeader';
